import React, { FormEvent } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { IUserData } from '@models/interfaces/user.interface';
import Cookies from 'js-cookie';
import AUTH_API from '@services/auth.service';
import './UserTypeCard.css';
import {
  USER_TYPE_PARENT,
  USER_TYPE_STUDENT,
  USER_TYPE_STUDENT_LEGACY,
} from '@utils/constants/user.constants';
import { useVerifyLogin } from '@hooks/user.hook';

type AppProps = {
  users: IUserData[];
  remember_me: boolean;
};
export default function UserTypeCard({ users, remember_me }: AppProps) {
  const navigate = useNavigate();
  const queryVerifyLogin = useVerifyLogin();

  const [searchParams] = useSearchParams();

  const handleTypeUser = (e: FormEvent, user: IUserData) => {
    e.preventDefault();
    queryVerifyLogin.mutate(user.user_uid, {
      onSettled() {
        const cookieDomain = window.location.hostname.replace(
          /(.*\.)?([^.]*\..*)/,
          '$2',
        );

        if (remember_me) {
          Cookies.set('uid', user.user_uid, {
            path: '/',
            domain: cookieDomain,
          });
          Cookies.set('user_type', String(user.user_type));
          if (user.last_login_date)
            Cookies.set('user_last_login', user.last_login_date);
        } else {
          Cookies.set('uid', user.user_uid, {
            expires: 1,
            path: '/',
            domain: cookieDomain,
          });
          Cookies.set('user_type', String(user.user_type), { expires: 1 });
          if (user.last_login_date)
            Cookies.set('user_last_login', user.last_login_date, {
              expires: 1,
            });
        }
        //* set cookie for login integration
        const domain = window.location.hostname.replace(
          /(.*\.)?([^.]*\..*)/,
          '$2',
        );

        //* convert milliseconds to expiry date for cookies
        const expiryDate = new Date();
        expiryDate.setTime((user.expired_at ?? 0) * 1000);

        //* handle if access_token is null / undefined
        Cookies.set('gbadmin_token', user.access_token ?? '', {
          expires: expiryDate,
          path: '/',
          domain: domain,
        });

        Cookies.set('is_login', '1');
        AUTH_API.defaults.headers.uid = user.user_uid;
        localStorage.removeItem('multipleAccountsLogin');
        localStorage.removeItem('rememberMeLogin');

        const user_type_string = String(user.user_type);

        if (
          user_type_string === USER_TYPE_STUDENT ||
          user_type_string === USER_TYPE_STUDENT_LEGACY
        ) {
          setTimeout(() => {
            navigate({
              pathname: '/mathematics/worksheets',
              search: searchParams.toString(),
            });
          }, 1000);
        } else if (user_type_string === USER_TYPE_PARENT) {
          setTimeout(() => {
            navigate('/parent');
          }, 1000);
        } else {
          setTimeout(() => {
            navigate({
              pathname: '/mathematics/worksheets',
              search: searchParams.toString(),
            });
          }, 1000);
        }
      },
    });
  };
  return (
    <>
      <div className="flex flex-col">
        {users.map((user: IUserData, idx: number) => {
          return (
            <a
              key={idx}
              onClick={e => handleTypeUser(e, user)}
              className="
                card-container
                mb-[26px] py-[24px] px-[32px] cursor-pointer rounded-[16px]
                bg-white hover:bg-primary-skyblue-light active:bg-primary-skyblue
                border-b border-r border-[#CFD7E5]
              "
            >
              <div className="flex gap-2 items-center py-2">
                <div className="min-w-[60px] w-[60px] h-[60px] bg-success-700 flex justify-center items-center rounded-full text-white">
                  {user.pp.length > 0 ? (
                    <img
                      src={user.pp}
                      className="rounded-full h-full w-full"
                      alt={'profile'}
                    />
                  ) : (
                    <p className="text-[24px] font-bold">
                      {user.first_name.charAt(0)}
                      {user.last_name.charAt(0)}
                    </p>
                  )}
                </div>
                <div className="ml-[24px] inline-block max-w-[calc(100%-10px)] text-ellipsis overflow-hidden">
                  <p className="font-black text-[16px] leading-[27px] max-h-[27px] text-primary-navyblue-dark text-ellipsis overflow-hidden whitespace-nowrap">
                    {user.first_name}
                  </p>
                  <p className="text-[16px] leading-[27px] text-neutral-pencil max-h-[27px] text-ellipsis overflow-hidden whitespace-nowrap">
                    {user.email_address}
                  </p>
                </div>
              </div>
            </a>
          );
        })}
      </div>
    </>
  );
}
